<template>
  <div class="badges-container">
    <div class="badges-header">
      <h2>{{ header ? header : "Badges" }}</h2>
      <div
        v-if="
          $store.getters.isCandidate &&
          unassignedBadges.length > 0 &&
          $store.getters.candidatesCanAssignBadge
        "
        class="input-group mb-2"
        style="max-width: 450px"
      >
        <select
          class="form-control"
          v-model="candidateSelectedBadge"
        >
          <option
            v-for="badge in unassignedBadges"
            :key="badge.id"
            :value="badge"
          >
            {{ badge.badge_name }}
          </option>
        </select>
        <button
          class="btn btn-secondary"
          @click="assignBadge()"
        >
          Add Badge
        </button>
      </div>
    </div>
    <div class="row">
      <p
        v-if="candidateBadgesList.length == 0"
        class="message"
      >
        No Badges Assigned
      </p>
      <div
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 py-4 px-3"
        v-for="badge in candidateBadgesList"
        :key="badge.id"
      >
        <div class="badges-card">
          <div class="badge-img">
            <img
              :src="badge.badge_image"
              alt=""
            />
          </div>
          <h5 class="title">{{ badge.badge_name }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDialog from "../common/global-dialogs/ModalDialog.vue";
import InputDialog from "../common/InputDialog.vue";
import { FORM_TYPE } from "../../constants/custom-define-type";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalDialog,
    InputDialog,
  },
  props: {
    user: Object,
    candidateCanAddBadge: Boolean,
    unassignedBadges: Array,
    header: String,
    badgeIds: Array,
  },
  data() {
    return {
      photos: [],
      isShow: false,
      isShowInputDialog: false,
      isShowConfirmDelete: false,
      selectedFile: null,
      selectedBadgeId: null,
      candidateSelectedBadge: null,
    };
  },
  computed: {
    ...mapGetters(["getBadges"]),
    listFieldsMetaData() {
      return [
        {
          type: FORM_TYPE.TEXTBOX,
          label: "Badge Title",
          model: "name",
        },
      ];
    },
    candidateBadgesList() {
      if (this.badgeIds) {
        if (!this.getBadges) {
          return [];
        }
        return this.getBadges.filter((item) => this.badgeIds.includes(item.id));
      } else {
        const uniqueBadge = [
          ...new Map(
            this.$store.getters.getSelectedCandidateBadges.map((item) => [
              item["badge_id"],
              item,
            ])
          ).values(),
        ];
        return uniqueBadge;
      }
    },
    agencyBadgesList() {
      return this.$store.getters.getBadges;
    },
  },
  methods: {
    async onChange() {
      this.selectedFile = this.$refs.addBadgeImage.files[0];
      if (this.selectedFile == null) {
        return;
      }
      if (this.selectedFile.size === 0) {
        this.showErrorDialog(this.$store.getters.emptyFileError);
        return;
      } else if (this.selectedFile.size > this.maxSizeInByte) {
        this.showErrorDialog(this.$store.getters.fileSizeExceedLimitError);
        return;
      }
      this.isShowInputDialog = true;
    },
    async submitMetaData(event) {
      // Upload file to server

      const form = new FormData();
      form.append("picture", this.selectedFile);
      form.append("name", event.name);
      form.append("user_id", this.user.id);

      const res = await axios.post(`/api/badge/create`, form);
      console.log(res);
      this.$refs.addBadgeImage.value = "";
    },
    async assignBadge() {
      if (
        this.candidateSelectedBadge.review_required &&
        this.candidateSelectedBadge.email !== null
      ) {
        axios
          .post("/api/candidate_badge/review_request", {
            agency_badge_id: this.candidateSelectedBadge.id,
            agency_id: this.candidateSelectedBadge.agency,
            user_id: this.user.id,
            from_email: this.$store.getters.agency.from_email,
            to_email: this.candidateSelectedBadge.email,
            sub_domain: window.location.host.split(".")[0],
          })
          .then(() => {
            this.showResultDialog({
              title: `Request has been sent. Badge will be added once approved`,
            });
          });
      } else {
        await axios.post("/api/candidate_badge/create", {
          candidate_badges: [
            {
              agency_badge: this.candidateSelectedBadge.id,
              agency: this.candidateSelectedBadge.agency,
              user: this.user.id,
            },
          ],
        });
        await this.$store.dispatch("getCandidateBadge", {
          candidateId: this.user.id,
        });
      }
      this.candidateSelectedBadge = null;
    },
    showDeletePhotoConfirmDialog(badgeId) {
      this.selectedBadgeId = badgeId;
      this.showConfirmDialog({
        key: "DELETE_PHOTO_CONFIRM_DIALOG",
        params: [selectedPhoto.name],
        onAcceptCallback: this.deletePhoto,
      });
    },
    async deletePhoto() {
      await axios.delete(`/api/badge/delete/${this.selectedBadgeId}`);
    },
  },
};
</script>

<style scoped>
.badges-container .badges-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--bootstrapgrey);
  padding-bottom: 1.3rem;
}
.badges-container .badges-card {
  border: 1px solid lightgray;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.badges-container h2 {
  font-size: 1.5rem;
  margin-bottom: 0;
  line-height: 1.5rem;
}
.badges-card .badge-img {
  width: 7rem;
  height: 7rem;
  display: flex;
  justify-content: center;
  margin: 0.8rem 0;
}
.badges-card .badge-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.badges-card .title {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  width: 100%;
  text-align: center;
}
.delete-badge {
  margin-left: 100%;
}
.message {
  margin: 0 auto;
  color: grey;
}
@media (min-width: 768px) and (max-width: 1368px) {
  .badges-card .badge-img {
    height: 4rem;
    width: 4rem;
  }
  .badges-card p {
    font-size: 0.8rem;
    font-weight: bold;
  }
}
@media (min-width: 992px) and (max-width: 1110px) {
  .badges-card p {
    font-size: 0.6rem;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/Badges.vue